import { Icon, Skeleton, SkeletonTable } from '@d-edge/overnight-hotelier-react'
import styles from './ui.module.css'

export function Spinner({ large = false }: { large?: boolean }) {
  return <Icon name="circle-notch" label="Loading" size={large ? 'large' : 'medium'} className={styles.spinner} role="status" />
}

/** Placeholder while a query loads: a skeleton table for tabular content, text lines otherwise. */
export function LoadingBlock({ kind = 'block' }: { kind?: 'block' | 'table' }) {
  if (kind === 'table') return <SkeletonTable rows={5} columns={4} />
  return (
    <div className={styles.skeletonBlock}>
      <Skeleton count={4} />
    </div>
  )
}
